module.exports = __webpack_public_path__ + "media/images/flags/4x3/dnk-d83d2b9840c398cb206bb19e6b124432.svg";